import L from 'leaflet'
import { ShipxyOptions } from '@map-sdk/sdk/config'

/**
 * 船舶实体类
 */
export class CanvasShip {
  custom_name = ''
  group_name = ''
  remark = ''
  source = 0
  source_real = 0
  mmsi: string
  shipid: string
  terminalid: undefined
  terminaltype: undefined
  lng: number
  lat: number
  hdg: number | undefined
  hdg_source: undefined
  cog: number | undefined
  sog: number | undefined
  rot: number | undefined
  navistatus: string
  lastdyn = 0
  lastdyn_active = false
  type: number | string
  name: string
  cnname: undefined
  nameen: undefined
  callsign: undefined
  imo = ''
  length: number
  width: number
  left: number
  trail: number
  draught: number
  dest: undefined
  eta: undefined
  laststa: undefined
  tracks: any[]
  istop: boolean //系统的停止
  color: string
  state: number
  pointCenterReal: undefined
  pointCenterGPS: undefined
  latlngReal: undefined
  latlng: undefined
  x: number
  y: number
  lineWidth: number
  rotate: number
  bodyArea: undefined
  head_x: undefined
  head_y: undefined
  shiptype: number | string
  datapower: number
  is_yh: boolean
  is_monitor: boolean
  monitorOnline: boolean
  outCN: boolean
  offset: number
  country: number
  txt_color = ''
  newtype: string
  lineColor: undefined
  heightLineColor: undefined
  options: undefined
  seaareaid: string
  isShowLableTime: undefined
  isShowLabel: undefined
  labelText: undefined
  is_radar: boolean
  radarid: undefined
  radarSource: undefined
  radarTarget: undefined
  gps_lat: number
  gps_lng: number
  gps_lastdyn: string
  serverTime: undefined
  shipxy_tooltip?: L.Tooltip
  arr_index!: number
  isSelected: boolean | undefined
  constructor() {
    this.mmsi = ''
    this.shipid = ''
    this.lng = 0
    this.lat = 0
    this.navistatus = ''
    this.type = ''
    this.name = ''
    this.length = 0
    this.width = 0
    this.left = 0
    this.trail = 0
    this.draught = 0
    this.tracks = []
    this.istop = false
    this.color = ''
    this.state = 2
    this.x = 0
    this.y = 0
    this.lineWidth = 1
    this.rotate = 0
    this.shiptype = ''
    this.datapower = 0
    this.is_yh = false
    this.is_monitor = false
    this.monitorOnline = false
    this.outCN = false
    this.offset = 0
    this.country = 0
    this.newtype = ''
    this.seaareaid = ''
    this.is_radar = false
    this.gps_lat = 0
    this.gps_lng = 0
    this.gps_lastdyn = ''
  }
  //  7200 | 345600> 服务器时间、秒 - 更新时间、秒 >  1800 此时是正常状态
  //   服务器时间、秒 - 更新时间、秒 <  1800 此时是初始状态
  //   服务器时间、秒 - 更新时间、秒 <  1800 此时是中间状态
  updateState(time: number) {
    const stateTime = time - Number(this.lastdyn)
    const status =
      1 === this.source
        ? ShipxyOptions.shipDataServer.shipStateGPSMaxTime
        : ShipxyOptions.shipDataServer.shipStateMaxTime
    stateTime < ShipxyOptions.shipDataServer.shipStateMinTime
      ? (this.state = 0)
      : (this.state = stateTime < status ? 1 : 2)
  }

  getLatlng() {
    return new L.LatLng(this.lat, this.lng)
  }

  setLatlng(latlng: undefined) {
    this.latlng = latlng
  }

  getPoint() {
    return new L.Point(this.x, this.y)
  }

  setPoint(point: { x: number; y: number }) {
    this.x = point.x
    this.y = point.y
  }
}
